import * as React from 'react';
import Box from '@mui/material/Box';
import { ContextData } from '../../../../../context/Context';
import { Getrequest, Putrequest } from '../../../../../context/AxiosRequest';
import { toast } from 'react-toastify';

export default function ApplyingType() {
  const { Value, setValue, UserTokens, accesstoken } = React.useContext(ContextData);
  const [DataValue, setDataValue] = React.useState('');

  // When user changes selection
  const handleChange = (event) => {
    const newValue = String(event.target.value).trim();
    setDataValue(newValue);

    if (!UserTokens) {
      toast.warn('Please refresh the page');
      return;
    }

    // only send update if the value actually changed from the currently stored Value
    if (newValue === (Value ?? '')) return;

    const data = { application_type: newValue, UserTokens };

    (async function updateAppType() {
      try {
        const response = await Putrequest(`/auth/update_application_type`, data, accesstoken);
        if (response.status) {
          setValue(newValue);
          toast.success(response.textStatus);
        } else {
          toast.error(response.textStatus);
        }
      } catch (err) {
        toast.error('Failed to update application type');
      }
    })();
  };

  // Fetch current application type on mount / when tokens change
  React.useEffect(() => {
    if (!accesstoken || !UserTokens) return;

    (async function fetchAppType() {
      try {
        const response = await Getrequest(`/auth/get_app_type/${UserTokens}`, accesstoken);
        const fetched = String(response?.[0]?.application_type ?? '').trim();
        if (fetched) {
          setDataValue(fetched);
          setValue(fetched); // sync context
        } else {
          setDataValue('');
        }
      } catch (err) {
        toast.error('Failed to fetch application type');
      }
    })();
  }, [accesstoken, UserTokens, setValue]);

  return (
    <Box sx={{ minWidth: 160 }}>
      <select
        onChange={handleChange}
        value={DataValue}
        className="w-full p-2 rounded-md bg-[#030323e6] text-white font-bold"
      >
      <option value="scholarship">Scholarship Application</option>  
        <option value="loan">Loan Application</option>
      </select>
    </Box>
  );
}
